export class ProRadDrawExecuteRequest {
  images: ProRadDrawImageRequest[];
}

export class ProRadDrawImageRequest {
  originalImageSourceUrl: string;
  originalImageGuid: string;
  currentImageSourceUrl: string;
  currentImageGuid: string;
}
